import React, {useEffect, useRef, useState} from 'react';
import {useHistory, useLocation} from "react-router-dom";
import './GlobalCPC.page.css';
import {
    Box,
    Button,
    Card,
    CardContent,
    CircularProgress,
    Divider,
    Grid,
    TextField,
    Typography,
    useMediaQuery
} from "@mui/material";
import CountryRanking from "./CountryRanking.comp";
import {
    contactUsIndexService,
    getCpciGlobalChildProtectionProgressService,
    getCyberRiskMonitorDataService,
    getCyberRiskTodayDataService,
    getGoalsIndexAllDataService
} from "../../services/elevate_cpc.service";
import {countries} from "../../utils/Countries";
import Footer from "../Methodology/Footer";
import backgroundImage3 from '../../assets/images/bg3.jpg';
import CyberRiskMonitorComp from "../Methodology/CyberRiskMonitor.comp";
import {toast, validateEmail} from "../../utils/utils";
import {STAKEHOLDERS_CATEGORY_COLOR_MAPPING, TOAST_TYPES} from "../../utils/constants";
import GraphIcon1 from "../../assets/images/GraphIcon1.png";
import GraphIcon2 from "../../assets/images/GraphIcon2.png";
import GraphIcon3 from "../../assets/images/GraphIcon3.png";
import GraphIcon4 from "../../assets/images/GraphIcon4.png";
import GraphIcon5 from "../../assets/images/GraphIcon5.png";
import GraphIcon6 from "../../assets/images/GraphIcon6.png";
import GraphIcon7 from "../../assets/images/GraphIcon7.png";
import backgroundImage from "../../assets/images/global_header_bg.jpg";
import Img10 from "../../assets/images/icon10.png";
import Img11 from "../../assets/images/icon11.png";
import Img2 from "../../assets/images/cyber-citizenship.png";

const GlobalCPC = () => {
    const location = useLocation();
    const [globalGoalsChartData, setGlobalGoalsChartData] = useState({});
    const [globalGoalsTableData, setGlobalGoalsTableData] = useState([]);
    const [cyberRiskMonitorData, setCyberRiskMonitorData] = useState({
        labels: [],
        datasets: []
    });
    const didFetchGoalsIndexAllData = useRef(false);
    const didFetchMonitorData = useRef(false);
    const didFetchGoalsPointsData = useRef(false);
    const [cpciChartData, setCpciChartData] = useState([]);
    const [cyberRiskTodayData, setCyberRiskTodayData] = useState([]);
    const didFetchTodayData = useRef(false);
    const [loading, setLoading] = useState(true);
    const history = useHistory();
    const isMobile = useMediaQuery("(max-width:780px)");
    const isTablet = useMediaQuery("(min-width:781px) and (max-width:1024px)");

    const partnershipOptions = [
        // "Government",
        "Education and Training",
        "Research",
        // "Data Source",
    ];

    const colorMapping = {
        "P1.IndiSkill": "#EBB941",
        "P1.IndiUse": "#00AF9B",
        "P1.Fam": "#F05F64",
        "P1.Sch": "#BE64C3",
        "P1.DESG": "#8269D2",
        "P1.Soft": "#007DB4",
        "P1.Hard": "#003C69",
    };

    const iconMapping = {
        "P1.IndiSkill": GraphIcon1,
        "P1.IndiUse": GraphIcon2,
        "P1.Fam": GraphIcon3,
        "P1.Sch": GraphIcon4,
        "P1.DESG": GraphIcon5,
        "P1.Soft": GraphIcon6,
        "P1.Hard": GraphIcon7,
    };
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [selectedOptions, setSelectedOptions] = useState([]);
    let dataIndex = 0;

    const GROUPS = [
        {size: 3, category: "Empowered Children"},
        {size: 2, category: "Safe Technology"},
        {size: 1, category: "Protective Policies"},
    ];

    useEffect(() => {
        if (didFetchGoalsPointsData.current) return;
        didFetchGoalsPointsData.current = true;
        getGoalsPointsIndexData().then(r => console.log("Goals Points Data Fetching Started"));
    }, []);

    useEffect(() => {
        if (didFetchTodayData.current) return;
        didFetchTodayData.current = true;
        const fetchCyberRiskTodayData = async () => {
            try {
                const response = await getCyberRiskTodayDataService();
                if (response.data.metaData) {
                    console.log('cyberRiskTodayData: ', response.data.metaData.cyber_risk_today);
                    setCyberRiskTodayData(response.data.metaData.cyber_risk_today);
                }
            } catch (error) {
                console.error("Error fetching Cyber Risk Today data:", error);
            }
        };
        fetchCyberRiskTodayData().then(r => console.log(r));
    }, []);

    const getGoalsPointsIndexData = async () => {
        try {
            setLoading(true);
            const response_global = await getCpciGlobalChildProtectionProgressService();

            const pointsObj = response_global?.data?.progressData || {};

            const meta = response_global?.data?.metaData || {};

            if (pointsObj && typeof pointsObj === "object") {
                const transformedData = Object.keys(pointsObj)
                    .filter((key) => key.startsWith("P1."))
                    .map((key) => {
                        const pt = pointsObj[key] || {};

                        const err100 = pt.error != null && pt.error < 1 ? pt.error * 100 : pt.error;

                        return {
                            name: (meta?.[key]?.["IndexL2 (Name)"] || key).toUpperCase(),
                            value: Math.round(pt.value ?? 0),   // 0–100 scale
                            error: err100 ?? null,
                            lower: pt.lower ?? (pt.value != null && err100 != null ? pt.value - err100 : null),
                            upper: pt.upper ?? (pt.value != null && err100 != null ? pt.value + err100 : null),

                            icon: iconMapping[key] || null,
                            color: colorMapping[key] || "#CCCCCC",
                        };
                    });

                console.log('globalChildProtectionProgressData: ', transformedData);
                setCpciChartData(transformedData);
            }
        } catch (error) {
            console.error("Error fetching CPC Index data:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (didFetchGoalsIndexAllData.current) return;
        didFetchGoalsIndexAllData.current = true;
        const fetchData = async () => {
            try {
                const {data} = await getGoalsIndexAllDataService();
                if (data && data.indexData) {
                    const filteredCountries = countries.filter(country =>
                        Object.prototype.hasOwnProperty.call(data.indexData, country.code)
                    );

                    const countriesTableData = filteredCountries.map(country => ({
                        flag: country.code,
                        name: country.label,
                        level: data.indexData[country.code] || "None"
                    }));
                    setGlobalGoalsTableData(countriesTableData);

                    const chartData = filteredCountries.reduce((acc, country) => {
                        acc[country.code] = data.indexData[country.code] || "None";
                        return acc;
                    }, {});
                    setGlobalGoalsChartData(chartData);
                }
            } catch (e) {
                console.error(e);
            }
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (didFetchMonitorData.current) return;
        didFetchMonitorData.current = true;
        const fetchCyberRiskMonitorData = async () => {
            try {
                const response = await getCyberRiskMonitorDataService();
                if (response.data.metaData) {
                    console.log('cyberRiskMonitorData: ', response.data.metaData);
                    setCyberRiskMonitorData(response.data.metaData);
                }
            } catch (error) {
                console.error("Error fetching Cyber Risk Monitor data:", error);
            }
        };
        fetchCyberRiskMonitorData().then(r => console.log(r));
    }, []);

    const handleSubmit = async () => {
        if (!validateEmail(email)) {
            toast(TOAST_TYPES.DANGER, "Failed", "Please enter a valid email address.");
        } else {
            try {
                const result = await contactUsIndexService(name, email, message, selectedOptions);
                if (result.data && result.data.success) {
                    toast(TOAST_TYPES.SUCCESS, "Successful", "Email sent and we will get back to you soon!");
                    setName('');
                    setEmail('');
                    setMessage('');
                }
            } catch (e) {
                // already toasted the error
            }
        }
    }

    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 3000);
        window.scrollTo(0, 0);

        if (location.hash) {
            const hash = location.hash.substring(1);
            const hashTimer = setTimeout(() => {
                const section = document.getElementById(hash);
                if (section) {
                    section.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 500);

            return () => {
                clearTimeout(timer);
                clearTimeout(hashTimer);
            };
        }

        return () => clearTimeout(timer);
    }, [location]);
    return (
        <>
            <Box className="globalHeader" sx={{
                marginTop: {xs: '0px', sm: '80px'},
                background: loading ? "linear-gradient(90deg, #e6e6e6 25%, #cccccc 50%, #e6e6e6 75%)" : `url(${backgroundImage}) center/cover no-repeat`,
                backgroundSize: loading ? "200% 100%" : "cover",
            }}>
                <Box className="globalHeaderContent">
                    <Typography sx={{
                        fontSize: {xs: "28px", md: '3rem', lg: "4.3rem"},
                        fontWeight: "bold",
                        lineHeight: '1.2',
                        mb: 2,
                        textTransform: 'uppercase',
                    }}>
                        2025 CHILD PROTECTION IN CYBERSPACE INDEX
                    </Typography>
                    <Typography className="subHeaderText">
                        Advancing Global Progress in Child Online Protection
                    </Typography>
                </Box>
            </Box>

            <Box className="sectionEmpower" sx={{
                position: "relative",
                display: "flex",
                alignItems: "stretch",
                flexDirection: {xs: "column", md: "row"},
                width: "100%",
            }}>
                <Box
                    sx={{
                        flex: {lg: 1.7},
                        backgroundColor: "#0096C8",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        px: {xs: "20px", md: "40px"},
                        py: {xs: "40px", md: "80px"},
                    }}
                >
                    <Typography
                        variant="h2"
                        sx={{
                            color: "#fff",
                            fontSize: {xs: "23px", md: "65px", lg: "70px",},
                            fontWeight: "bold",
                            textAlign: {xs: "center", md: "left"},
                            marginLeft: {xs: '0px', lg: '80px'},
                        }}
                    >
                        What is the Child Protection in Cyberspace Index?
                    </Typography>
                </Box>
                <Box
                    sx={{
                        flex: {lg: 2},
                        backgroundColor: "#fff",
                        color: '#003D69',
                        display: "flex",
                        flexDirection: 'column',
                        alignItems: "center",
                        textAlign: 'left',
                        px: {xs: "20px", md: '50px', lg: "100px"},
                        py: {xs: "40px", md: "80px"},
                    }}
                >
                    <Typography sx={{
                        fontSize: {xs: '17px', sm: '25px'},
                        lineHeight: '1.2',
                        fontWeight: '600',
                        marginBottom: 2,
                    }}>
                        The CPC Index is a global collaborative platform that measures and advances child online
                        safety through{' '}
                        <a href="/methodology"
                           style={{textDecoration: 'underline', color: 'inherit', fontWeight: 600}}>
                            unified global standards.
                        </a>
                    </Typography>
                    <Typography sx={{fontSize: {xs: '17px', sm: '25px'}, lineHeight: '1.2', marginBottom: 2,}}>
                        Without a common framework, progress is fragmented and hard to measure. By harmonizing
                        global research into one system, the Index aims
                        to empower all stakeholders – from governments and industry, to schools and families – track
                        progress and accelerate action toward the
                        shared goal of reducing child cyber-risks.
                    </Typography>
                    <Typography sx={{fontSize: {xs: '17px', sm: '25px'}, lineHeight: '1.2', marginBottom: 2,}}>
                        The challenge is the scarcity of reliable data. As technology and policy evolve rapidly,
                        many national profiles can quickly become incomplete or outdated.
                    </Typography>
                    <Typography sx={{fontSize: {xs: '17px', sm: '25px'}, lineHeight: '1.2',}}>
                            <span style={{textDecoration: "underline",fontWeight:'bold', cursor: "pointer",}} onClick={() => {
                                const section = document.getElementById("homeContactSection");
                                if (section) {
                                    section.scrollIntoView({behavior: "smooth"});
                                }
                            }}>Join the global effort </span>
                        – Help us update your national profile, build the most accurate picture of child online
                        safety - driving measurable progress to protect every child online.
                    </Typography>
                </Box>
            </Box>

            <Box sx={{marginTop: '80px', marginBottom: '80px'}}>
                <CountryRanking data={globalGoalsTableData}/>
            </Box>

            <Box className="goalSection" style={{background: `url(${backgroundImage3}) top/cover no-repeat`}}>
                <Box className="goalText">
                    <Typography sx={{
                        color: '#fff',
                        fontSize: {xs: '28px', sm: '85px', md: '60px', lg: '85px'},
                        textTransform: 'uppercase',
                        fontWeight: 'bold',
                        paddingLeft: {xs: '0px', sm: '20px !important'},
                        textAlign: 'center',
                    }}>
                        OUR MISSION:
                    </Typography>
                    <Typography className="subTitle" sx={{
                        marginTop: {xs: '0px', md: '-10px', lg: '-30px'},
                        textAlign: {xs: 'center', sm: 'center'},
                        lineHeight: '1.2',
                        color: '#fff !important',
                        fontSize: {xs: '25px', sm: '50px', md: '45px', lg: '50px'},
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        paddingLeft: {xs: '0px', sm: '20px !important', md: '32px', lg: '20px'},
                    }}>
                        REDUCE CHILD CYBER RISKS BY AT LEAST 15% IN 5 YEARS
                    </Typography>
                </Box>
            </Box>

            <Box sx={{
                position: 'relative',
                padding: {xs: '30px 10px 30px 10px', md: '100px 30px 50px 30px', lg: '100px 30px 0 30px'},
                display: 'flex',
                flexDirection: 'column',
                backgroundColor: '#003D69',
                width: '100%',
            }}>
                <Typography sx={{
                    color: '#fff',
                    fontSize: {xs: '25px', sm: '55px', md: '45px', lg: '55px'},
                    fontWeight: 'bold',
                    textTransform: 'uppercase',
                    paddingLeft: {xs: '10px', sm: '20px !important',},
                    paddingRight: {xs: '10px', sm: undefined,},
                    textAlign: 'center',
                    marginBottom: {xs: '20px', sm: undefined},
                }}>
                    Global child cyber risk monitor
                </Typography>
                <Typography sx={{
                    color: '#fff',
                    fontWeight: 'bold',
                    textAlign: 'left',
                    fontSize: {xs: '17px', sm: '25px'},
                    paddingLeft: {xs: '10px', sm: '20px', lg:'70px'},
                    paddingRight: {xs: '10px', sm: undefined,lg:'70px'}
                }}>
                    This monitor tracks the Global Child Cyber Risks (GCCR), representing the percentage of children
                    (aged 8-18) who have experienced at least one type of cyber risk in the past year.
                </Typography>
                <Typography sx={{
                    color: '#fff',
                    mt: 2,
                    textAlign: 'left',
                    fontSize: {xs: '17px', sm: '25px'},
                    paddingLeft: {xs: '10px', sm: '20px', lg:'70px'},
                    paddingRight: {xs: '10px', sm: undefined,lg:'70px'}
                }}>
                    This GCCR indicator is built on 12 key risk indicators (see below) and is updated regularly to
                    reflect the fast-changing nature
                    of technology and children’s online experiences.{' '}
                    <a href="/methodology" style={{textDecoration: 'underline', color: 'inherit',}}>
                        Learn more.
                    </a>
                </Typography>
                <Typography sx={{
                    color: '#fff',
                    mt: 2,
                    textAlign: 'left',
                    fontSize: {xs: '17px', sm: '25px'},
                    paddingLeft: {xs: '10px', sm: '20px', lg:'70px'},
                    paddingRight: {xs: '10px', sm: undefined,lg:'70px'}
                }}>
                    To understand the evolution of child cyber-risks, the 2025 CPC Index also examines trends across
                    three critical periods of global digital transition:
                </Typography>
                <Typography sx={{
                    color: '#fff',
                    mt: 1,
                    textAlign: 'left',
                    fontSize: {xs: '17px', sm: '25px'},
                    paddingLeft: {xs: '10px', sm: '20px', lg:'70px'},
                    paddingRight: {xs: '10px', sm: undefined,lg:'70px'}
                }}>
                    <ul style={{lineHeight: 1.6, marginTop: '10px'}}>
                        <li>
                            <strong style={{color: '#0096C8',}}>Pre-COVID (2017–2019):</strong> Baseline patterns of
                            online behavior.
                        </li>
                        <li>
                            <strong style={{color: '#0096C8',}}>COVID-19 Pandemic (2020–2022):</strong> A period of
                            accelerated digitalization.
                        </li>
                        <li>
                            <strong style={{color: '#0096C8',}}>Post-COVID / Technology Transition
                                (2023–2025):</strong> Defined by the normalization of digital life after the
                            pandemic and the profound technological shift brought by the mainstream adoption of
                            generative AI.
                        </li>
                    </ul>
                </Typography>

                <CyberRiskMonitorComp cyberRiskMonitorData={cyberRiskMonitorData}/>
                <Box sx={{padding: {xs: '4px 14px', sm: '4px 4px 4px 0px', lg: '4px 70px 4px 70px'}, borderRadius: 2, width: "100%"}}>
                    <Grid container spacing={0} sx={{
                        flexWrap: "nowrap",
                        overflow: 'hidden',
                        alignItems: 'start',
                        justifyContent: 'space-between',
                        display: "flex"
                    }}>
                        {/* First Label */}
                        <Grid item xs="auto">
                            <Box sx={{
                                display: {xs: 'none', sm: "flex"},
                                alignItems: "center",
                                flexDirection: {xs: "column", sm: "row"},
                                textAlign: {xs: "center", sm: "left"},
                                marginLeft: {xs: '-10px', sm: 'auto'},
                            }}>
                                <Box sx={{
                                    width: {xs: 13, sm: 22},
                                    height: {xs: 13, sm: 22},
                                    borderRadius: "50%",
                                    backgroundColor: "#FFFFFF",
                                    mb: {xs: 1, sm: 'auto'},
                                }}/>
                                <Typography sx={{
                                    color: "#FFFFFF",
                                    fontSize: {xs: '10px', sm: '15px'},
                                    maxWidth: {xs: "55%", sm: "100%"},
                                    lineHeight: "1.5",
                                    overflowWrap: "anywhere",
                                    ml: {xs: 0, sm: 1}
                                }}>
                                    Experienced At Least <br/> 1 Cyber Risk
                                </Typography>
                            </Box>
                        </Grid>

                        {/* Labels - 4-items each row */}
                        <Grid container spacing={2} sx={{ml: {md: "20px", lg:'65px'}}}>
                            {cyberRiskMonitorData && cyberRiskMonitorData.datasets ? (
                                (isMobile ? cyberRiskMonitorData.datasets : cyberRiskMonitorData.datasets.slice(1)).map((dataset, index) => (
                                    <Grid item xs={4} sm={6} md={4} lg={3} key={index}>
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                flexDirection: {xs: 'column', sm: 'row'},
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    width: {xs: 13, sm: 22},
                                                    height: {xs: 13, sm: 22},
                                                    borderRadius: "50%",
                                                    backgroundColor: dataset.backgroundColor,
                                                    marginRight: 1,
                                                    mb: {xs: 1, sm: 'auto'},
                                                    flexShrink: 0,
                                                }}
                                            />
                                            <Typography
                                                sx={{
                                                    color: "#FFFFFF",
                                                    fontSize: {xs: "10px", sm: "15px"},
                                                    textAlign: {xs: 'center', sm: 'left'},
                                                    whiteSpace: "normal",
                                                    lineHeight: {xs: "14px", sm: "20px"},
                                                    height: {sm: "auto"},
                                                    overflowWrap: "anywhere",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    maxWidth: {xs: '200px', md: '200px', lg: '240px'},
                                                }}
                                            >
                                                {dataset.label}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                ))
                            ) : (
                                // Show loading state while data is being fetched
                                <Grid item xs={12}>
                                    <Typography sx={{color: "#FFFFFF"}}>
                                        Loading data...
                                    </Typography>
                                </Grid>
                            )}
                        </Grid>

                    </Grid>
                </Box>
            </Box>

            <Box style={{backgroundColor: '#003D69', paddingBottom: '100px',}}>
                <Box sx={{backgroundColor: "#003D69", py: {xs: 8, md: 12}, textAlign: "center"}}>

                    {/* Top Center Stat */}
                    <Box>
                        <Typography variant="h2" sx={{color: "white", fontWeight: "bold"}}>
                            <Typography component="span" sx={{fontSize: {xs: "100px", md: "300px"}, fontWeight: "bold"}}>
                                {Object.values(cyberRiskTodayData || {})[0]?.value ?? 0}
                            </Typography>
                            <Typography component="span" sx={{fontSize: {xs: "30px", md: "100px"}, ml: 1}}>
                                %
                            </Typography>
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            sx={{
                                fontSize: {xs: "14px", md: "28px"},
                                color: "white",
                                mx: "auto",
                                mt: {xs: -2, md: -8},
                                lineHeight: '1.1'
                            }}
                        >
                            OF 8-18 YEAR-OLD CHILDREN WORLDWIDE<br/> EXPERIENCE AT LEAST 1 CYBER RISK TODAY
                        </Typography>
                    </Box>

                    {/* Circle Grid */}
                    <Grid container spacing={4} justifyContent="flex-start"
                          sx={{mt: 6, width: {xs: '90%', lg: '70%'}, mx: 'auto'}}>
                        {Object.entries(cyberRiskTodayData || {}).slice(1).map(([key, {value, text, subtext}]) => (
                            <Grid item xs={6} sm={3} key={key} sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                paddingLeft: {xs: '0px !important', sm: 'auto'}
                            }}>
                                {/* Circular Progress */}
                                <Box sx={{position: "relative", display: "inline-flex"}}>
                                    {/* Background Circle */}
                                    <CircularProgress
                                        variant="determinate"
                                        value={100}
                                        size={isMobile ? 100 : isTablet ? 190 : 220}
                                        thickness={5}
                                        sx={{
                                            color: "#fff",
                                            position: "absolute",
                                        }}
                                    />

                                    {/* Progress Circle */}
                                    <CircularProgress
                                        variant="determinate"
                                        value={value}
                                        size={isMobile ? 100 : isTablet ? 190 : 220}
                                        thickness={5}
                                        sx={{
                                            color: "#F05F65",
                                        }}
                                    />

                                    {/* Text in Center */}
                                    <Box
                                        sx={{
                                            top: 0,
                                            left: 0,
                                            bottom: 0,
                                            right: 0,
                                            position: "absolute",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <Typography sx={{
                                            fontWeight: "bold",
                                            fontSize: {xs: '25px', md: '45px', lg: "50px"},
                                            color: "#ffff"
                                        }}>
                                            {value}%
                                        </Typography>
                                    </Box>
                                </Box>


                                {/* Labels */}
                                <Typography
                                    sx={{
                                        fontWeight: "bold",
                                        fontSize: {xs: "14px", md: "18px"},
                                        color: "#F05F65",
                                        mt: 2,
                                        width: '70%',
                                    }}
                                >
                                    {text}
                                </Typography>
                                {subtext && (
                                    <Typography sx={{fontWeight: "bold", fontSize: "15px", color: "#fff",}}>
                                        {subtext}
                                    </Typography>
                                )}
                            </Grid>
                        ))}
                    </Grid>
                </Box>

                <Box sx={{
                    flex: '1',
                    marginTop: {xs: '-130px', sm: '0px'},
                    mt: 3,
                    textAlign: 'center',
                    position: 'relative'
                }}>
                    <Box sx={{
                        position: 'absolute',
                        top: {xs: '120px', sm: '120px'},
                        left: {xs: '6%', md: '6%', lg: '6.3%'},
                        textAlign: 'left',
                        width: {xs: '60%', md: '42%', lg: '37%'}
                    }}>
                        <Typography
                            sx={{
                                fontSize: {xs: '23px', sm: '39px', md: '40px'},
                                fontWeight: 'bold',
                                color: 'white',
                                lineHeight: '1.1'
                            }}
                        >
                            CHILD CYBER RISKS: <br/> A THREAT TO CHILD DEVELOPMENT, HEALTH, AND WELL-BEING
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: {xs: '17px', sm: '25px', lg: '25px'},
                                color: 'white',
                                lineHeight: '1.2',
                                marginTop: {xs: '15px', sm: '22px'},
                                marginBottom: {md: '560px',}
                            }}
                        >
                            Equipping children with cyber citizenship is an urgent national call to reduce child
                            cyber risks
                        </Typography>
                    </Box>

                    <Box
                        component="img"
                        src="https://storage.googleapis.com/poweredbydq/assets/images/cyber-risks.png"
                        alt="Action Support"
                        sx={{
                            marginTop: {xs: '365px', md: '350px', lg: '240px'},
                            maxWidth: {xs: '92%', sm: '75%'},
                            borderRadius: '0px',
                        }}
                    />
                </Box>

            </Box>


            <Box className="sectionEmpower" sx={{
                position: "relative",
                display: "flex",
                alignItems: "stretch",
                flexDirection: {xs: "column", md: "row"},
                width: "100%",
            }}>
                <Box
                    sx={{
                        flex: 1,
                        backgroundColor: "#0096C8",
                        display: "flex",
                        flexDirection: 'column',
                        textAlign: 'left',
                        alignItems: "center",
                        justifyContent: "center",
                        px: {xs: "20px", md: "40px"},
                        py: {xs: "40px", md: "80px"},
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: {xs: '20px', md: '40px', lg: '50px'},
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            paddingLeft: {xs: '0px', lg: '65px'},
                            lineHeight: '1.1'
                        }}
                    >
                        WE NEED RADICAL GLOBAL ACTIONS TO SUPPORT NATIONS NOW.
                    </Typography>
                    <br/>
                    <Typography sx={{
                        fontSize: {xs: '17px', sm: '25px'},
                        fontWeight: '500',
                        paddingLeft: {xs: '0px', lg: '65px'},
                        mb: 3,
                    }}
                    >
                        With the rapid advancement of generative AI, this figure may rise dramatically. We have a brief
                        window to implement effective child safety measures before the full activation of this new AI
                        era.
                    </Typography>
                </Box>
                <Box
                    sx={{
                        flex: 1,
                        backgroundColor: "#fff",
                        color: '#003D69',
                        display: "flex",
                        flexDirection: 'column',
                        alignItems: "center",
                        justifyContent: 'center',
                        textAlign: 'left',
                        px: {xs: "20px", md: "40px"},
                        py: {xs: "40px", md: "80px"},
                    }}
                >
                    <img
                        src="https://storage.googleapis.com/poweredbydq/assets/images/cyber-risks-actions-graph_05.png"
                        alt="Action Support"
                        style={{
                            maxWidth: '75%',
                            height: 'auto',
                            borderRadius: '0px',
                        }}
                    />
                </Box>
            </Box>

            <Box sx={{paddingTop: {xs: '30px', sm: '100px'}, px: {xs: '20px', md: '60px', lg: '0px', xl: '30px',}}}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    fontWeight: 'bold',
                    justifyContent: 'center',
                    flexDirection: 'column'
                }}>
                    <Typography variant="h4" className="title"
                                sx={{
                                    fontSize: {xs: '23px', sm: '2.125rem', md: '37px', lg: '2.125rem'},
                                    fontWeight: 'bold',
                                    color: '#003C69'
                                }}>
                        EMPOWERING EVERY CHILD WITH
                    </Typography>
                    <Typography variant="h3" className="highlightedText"
                                sx={{fontSize: {xs: '24px', sm: '3rem'}, fontWeight: 'bold', color: '#0096C8',}}>
                        CYBER CITIZENSHIP COMPETENCIES
                    </Typography>
                    <Typography variant="h4" className="title"
                                sx={{
                                    fontSize: {xs: '23px', sm: '2.125rem', md: '37px', lg: '2.125rem'},
                                    fontWeight: 'bold',
                                    color: '#003C69'
                                }}>
                        IS ESSENTIAL TO REDUCING CHILD CYBER RISKS
                    </Typography>
                    <Typography className="subText"
                        sx={{ fontSize: {xs: '17px', sm: '20px', md:'25px',  lg:'25px',},
                        textAlign: 'left',
                        marginBottom: 4,
                        px: {xs: '0px', md:'0px', lg: '70px'},}}>
                        <span style={{fontWeight: 'bold'}}>Cyber Citizenship</span> defines the essential
                        competencies children need to mitigate cyber risks while navigating Cyberspace safely,
                        responsibly, and effectively. It serves as a targeted set of cyber literacy and media
                        literacy competencies.
                        <br/><br/>
                        Research shows that when children are equipped with comprehensive cyber citizenship
                        competencies, <a
                        href='https://www.weforum.org/stories/2018/02/digital-intelligence-internet-safety-future/'
                        target='_blank' style={{color: "#0096C8"}}>child cyber risks can be reduced by 15%</a>.
                        Guided by this insight, our vision aims to achieve a minimum 15% reduction in child
                        cyber risks globally, compared to the pre-GenAI era.
                    </Typography>
                </Box>
                <Box sx={{
                    display: 'block',
                    width: {xs: '100%', md: '82%', lg: '65%'},
                    height: {xs: undefined,},
                    marginLeft: {xs: '0px', md: '85px', lg: 'auto'},
                    marginRight: {xs: '0px', md: '85px', lg: 'auto'},
                }} component="img"
                     src="https://storage.googleapis.com/poweredbydq/assets/images/cc-framework_01.png"
                     alt="Cyber Citizenship" className="image"/>
            </Box>

            <Box sx={{
                display: 'flex',
                marginTop: {xs: '215px', md: '150px', lg: '210px'},
                flexDirection: {xs: 'column', md: 'row'},
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#0097C7',
                width: '100%',
                mt: '40px',
                py: {xs: '50px', sm: '100px',},
            }}>
                <Box sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    px: {xs: '20px', md: '60px', lg: 'auto'},
                    marginLeft: {xs: '0px', lg: '155px'},
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    width: '100%'
                }}>
                    <Typography sx={{
                        display: 'block',
                        textAlign: 'left',
                        fontSize: {xs: '20px', sm: '30px', lg: '35px'},
                        lineHeight: '1.2',
                        zIndex: '2',
                        width: {xs: '100%', sm: '100%', lg: '85%'},
                        textTransform: 'none',
                        color: '#fff',

                    }}>
                        Higher Cyber Citizenship Skills can <span style={{fontWeight: 'bold'}}> enhance psychological strength, cognitive and social
                    development, and safe and responsible online behavior.</span>
                    </Typography>
                </Box>

                <Box sx={{
                    display: 'block',
                    width: {xs: '70%', md: '45%', lg: '32%'},
                    marginLeft: '0px',
                    marginTop: {xs: '75px', sm: 'auto'},
                    marginRight: {xs: '0px', md: '40px', lg: '220px'},
                    zIndex: '2',
                }} component="img" src={Img2} alt="Cyber Citizenship" className="leftImage"/>

            </Box>


            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                padding: {
                    xs: '40px 20px 50px 20px',
                    sm: '20px 20px 140px 20px',
                    md: '20px 40px 140px 40px',
                    lg: '100px 30px 140px 30px',
                },
            }}>
                <Typography variant="h3" className="title" sx={{
                    color: '#003C69',
                    fontSize: {xs: '23px', sm: '45px'},
                    width: {xs: '100%', lg: '70%'},
                    fontWeight: 'bold'
                }}>
                    Track Global Child Online Protection Progress
                </Typography>
                <Typography variant="h5" className="highlightedText" sx={{
                    width: '100%',
                    fontSize: {xs: '17px', sm: '25px'},
                    marginTop: '25px',
                    textAlign: 'left',
                    marginBottom: '3px',
                    color: '#003C69',
                    px: {xs: '0px', md:'0px', lg: '70px'},
                }}>
                    The CPC Index is a global initiative to standardize child online protection metrics, enabling
                    nations to assess, coordinate, and improve their efforts.
                    Today, fragmented and inconsistent data make it difficult for governments to identify gaps or
                    measure progress. CPC Index provides a unified, data-driven
                    framework to track, improve, and monitor child online protection—bringing the world closer to
                    our mission.
                </Typography>

                <Typography
                    sx={{
                        fontSize: {xs: '21px', sm: '35px'},
                        color: '#0096C8',
                        fontWeight: 'bold',
                        textAlign: 'center',
                        mx: 'auto',
                        mt: 2,
                        mb: 10,
                        paddingLeft: {xs: undefined, md: '20px', lg: undefined}
                    }}
                >
                    Global Average CPC Index Scores
                </Typography>

                <Box display="flex" flexDirection="column" alignItems="center"
                     sx={{width: {xs: '100%', sm: "985px"}}}>
                    <Box display="flex" flexDirection="column" alignItems="center"
                         sx={{marginTop: {xs: '20px', sm: '23px'}, maxWidth: {xs: '320px', sm: "985px"}}}>

                        {/* Bars + Baseline wrapper */}
                        <Box display="flex" justifyContent="center" alignItems="flex-end" width="100%"
                             sx={{
                                 height: {xs: '202px', md: '302px'},
                                 minHeight: {xs: '202px', md: "302px"},
                                 maxWidth: {xs: '78vw', md: '83vw', lg: "90vw"},
                                 position: "relative",
                                 borderTop: '2px solid #003C69',
                                 borderBottom: '2px solid #003C69'
                             }}>

                            {/* VALUE INDEXES */}
                            <Box
                                sx={{
                                    position: "absolute",
                                    left: {xs: '-28px', sm: "-50px"},
                                    bottom: 0,
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "space-between",
                                    height: {xs: '206px', md: "315px"},
                                }}
                            >
                                <Typography
                                    sx={{fontSize: {xs: "10px", sm: "25px"}, fontWeight: "bold", color: "#003C69"}}>
                                    100
                                </Typography>
                                <Typography sx={{
                                    fontSize: {xs: "10px", sm: "25px"},
                                    mb: {xs: '-8px', sm: '-18px'},
                                    fontWeight: "bold",
                                    color: "#003C69"
                                }}>
                                    0
                                </Typography>
                            </Box>

                            {/* All Groups */}
                            {GROUPS.map((group, gIndex) => {
                                const bars = cpciChartData.slice(dataIndex, dataIndex + group.size);
                                dataIndex += group.size;

                                const categoryColor = group.category
                                    ? STAKEHOLDERS_CATEGORY_COLOR_MAPPING[group.category]
                                    : "#F05F64";

                                return (
                                    <Box key={gIndex} display="flex" flexDirection="row" alignItems="flex-end"
                                         mx={{xs: 0, sm: 0}}>

                                        {/* Bars */}
                                        {bars.map((data, index) => {
                                            // scale factor for 0–100 → px ,{ xs: 2, sm: 3 };

                                            // convert lower & upper to heights in px
                                            const lowerHeight = data.lower != null ? {
                                                xs: data.lower * 2,
                                                sm: data.lower * 3
                                            } : null;
                                            const upperHeight = data.upper != null ? {
                                                xs: data.upper * 2,
                                                sm: data.upper * 3
                                            } : null;

                                            return (
                                                <Box key={index} display="flex" flexDirection="column"
                                                     alignItems="center" mx={{xs: '5px', sm: 2}}
                                                     sx={{position: "relative"}}>

                                                    {/* Bar */}
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                        sx={{
                                                            width: {xs: "27px", sm: 90},
                                                            height: {xs: data.value * 2, sm: data.value * 3},
                                                            backgroundColor: categoryColor,
                                                        }}
                                                    >
                                                        <Typography variant="h4" color="white" mt={1}
                                                                    fontWeight="bold" sx={{
                                                            zIndex: 999,
                                                            fontSize: {xs: '10px', sm: '25px'}
                                                        }}>
                                                            {data.value}
                                                        </Typography>
                                                    </Box>

                                                    {/* Error Bar (at the top of each bar) */}
                                                    {lowerHeight != null && upperHeight != null && (
                                                        <Box
                                                            sx={{
                                                                position: "absolute",
                                                                bottom: lowerHeight,
                                                                height: {
                                                                    xs: upperHeight.xs - lowerHeight.xs,
                                                                    sm: upperHeight.sm - lowerHeight.sm,
                                                                },
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignItems: "center",
                                                                justifyContent: "space-between",
                                                                zIndex: 999,
                                                            }}
                                                        >
                                                            {/* Top cap */}
                                                            <Box
                                                                sx={{
                                                                    width: {xs: "15px", sm: "30px"},
                                                                    height: "1px",
                                                                    backgroundColor: '#F05F64',
                                                                    boxShadow: "0 0 6px rgba(240,95,100,0.7)",
                                                                }}
                                                            />
                                                            {/* Vertical line */}
                                                            <Box
                                                                sx={{
                                                                    width: "1px",
                                                                    flexGrow: 1,
                                                                    backgroundColor: '#F05F64',
                                                                    boxShadow: "0 0 6px rgba(240,95,100,0.7)",
                                                                }}
                                                            />
                                                            {/* Bottom cap */}
                                                            <Box
                                                                sx={{
                                                                    width: {xs: "15px", sm: "30px"},
                                                                    height: "1px",
                                                                    backgroundColor: '#F05F64',
                                                                    boxShadow: "0 0 6px rgba(240,95,100,0.7)",
                                                                }}
                                                            />
                                                        </Box>
                                                    )}
                                                </Box>
                                            );
                                        })}

                                        {/* Divider after group */}
                                        {gIndex < GROUPS.length - 1 && (
                                            <Box display="flex" flexDirection="column" alignItems="center"
                                                 justifyContent="center" mx={{xs: 1, sm: 3}} height="100%">
                                                <Box sx={{
                                                    borderLeft: "1px dashed #003C69",
                                                    height: {xs: "320px", sm: "505px"},
                                                    mt: "-40px",
                                                    mb: {xs: "-100px", sm: "-170px"},
                                                }}/>
                                            </Box>
                                        )}
                                    </Box>
                                );
                            })}

                        </Box>

                        {/* Labels BELOW the baseline */}
                        <Box display="flex" justifyContent="center" mt={2} mr={{md: '24px', lg: '0px'}}
                             pl={{xs: '40px', sm: 'auto'}} px={{md: '55px', lg: "70px"}}
                             gap={{xs: '15px', md: '30px', lg: "30px"}}>
                            {GROUPS.map((group, gIndex) => {
                                const bars = cpciChartData.slice(
                                    gIndex === 0 ? 0 : GROUPS.slice(0, gIndex).reduce((a, g) => a + g.size, 0),
                                    GROUPS.slice(0, gIndex + 1).reduce((a, g) => a + g.size, 0)
                                );

                                const categoryColor = group.category
                                    ? STAKEHOLDERS_CATEGORY_COLOR_MAPPING[group.category]
                                    : "#F05F64";

                                return (
                                    <Box key={gIndex} display="flex" flexDirection="column" alignItems="center"
                                         gap="30px" flex={`${bars.length}`}>

                                        {/* Bar Labels */}
                                        <Box display="flex" justifyContent="center" flex="1" height={{
                                            xs: '40px',
                                            sm: "75px"
                                        }}>                                            {bars.map((data, index) => (
                                            <Typography
                                                key={index}
                                                variant="body2"
                                                fontWeight="bold"
                                                sx={{
                                                    color: categoryColor,
                                                    fontSize: {xs: '4px', sm: '13px'},
                                                    textAlign: "center",
                                                    // width: `${100 / bars.length}%`,
                                                    mx: {xs: '5px', sm: 2}
                                                }}
                                            >
                                                {data.name}
                                            </Typography>
                                        ))}
                                        </Box>

                                        {/* Category Label */}
                                        {group.category && (
                                            <Typography
                                                variant="h4"
                                                fontWeight="bold"
                                                sx={{
                                                    width: {xs: '65px', sm: '122px'},
                                                    mt: 1,
                                                    color: categoryColor,
                                                    fontSize: {xs: '7px', sm: '19px'},
                                                    textTransform: 'uppercase',
                                                    textAlign: "center",
                                                }}
                                            >
                                                {group.category}
                                            </Typography>
                                        )}
                                    </Box>
                                );
                            })}
                        </Box>
                        {/* Top Line (100 marker) */}
                        <Box
                            sx={{
                                position: "absolute",
                                top: 3, // ~3px from top
                                left: 0,
                                right: 0,
                                borderBottom: "2px solid #003C69",
                            }}
                        />

                    </Box>

                    <Box sx={{textAlign: 'center', marginTop: {xs: '80px', sm: '140px'}}}>
                        <Button
                            variant="contained"
                            sx={{
                                width: {xs: '100%', sm: '67%'},
                                textAlign: 'center',
                                backgroundColor: '#003C69',
                                color: '#fff',
                                fontSize: {xs: '18px', sm: '22px'},
                                fontWeight: 'bold',
                                lineHeight: '1.2',
                                textTransform: 'none',
                                border: '2px solid #003C69',
                                borderRadius: '0px',
                                padding: '15px 45px',
                                '&:hover': {
                                    backgroundColor: '#003C69',
                                },
                            }}
                            onClick={() => {
                                history.push('/national_cpc');
                            }}
                        >
                            PLAN YOUR NATION'S CHILD ONLINE PROTECTION JOURNEY
                        </Button>
                    </Box>
                </Box>


            </Box>

            <Box sx={{
                backgroundColor: '#0096C8',
                px: {xs: '10px', md: '24px', lg: '30px'},
                pb: '30px',
                pt: {xs: '30px', sm: 'auto'}
            }}>
                <Box sx={{
                    display: 'flex',
                    flexDirection: {xs: 'column', sm: 'column'},
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: {xs: '15px', lg: '0'},
                    marginTop: {xs: '0px', lg: '50px'},
                }}>
                    <Box sx={{display: 'flex', flexDirection: 'column', maxWidth: {xs: '100%', lg: '94%',}}}>
                        <Typography
                            sx={{
                                flex: 1,
                                textAlign: {xs: 'center', sm: 'center'},
                                fontSize: {xs: '23px', sm: '45px'},
                                fontWeight: 'bold',
                                color: '#fff',
                                marginX: {xs: '0px', lg: '40px'},
                                lineHeight: {xs: '1', sm: '1.5'},
                                marginTop: {xs: '30px'}
                            }}
                        >
                            Join the CPC Index Movement
                        </Typography>
                        <Typography variant="body2"
                                    sx={{
                                        flex: 1,
                                        textAlign: 'left',
                                        fontSize: {xs: '17px', sm: '25px'},
                                        lineHeight: '1.2',
                                        fontWeight: 'normal',
                                        color: '#fff',
                                        marginLeft: {xs: '0px', lg: '24px'},
                                        marginTop: '20px'
                                    }}
                        >
                            <b>We invite nations, organizations, and experts to collaborate in advancing child
                            online protection.</b>{' '}
                            By contributing knowledge and experience from the ground, you help ensure that global
                            benchmarks reflect real national
                            contexts. Through this collaboration, you gain valuable insights to identify strengths,
                            uncover gaps, and shape effective,
                            evidence-based strategies. Together, we can drive measurable progress and reduce child
                            cyber risks worldwide.
                        </Typography>
                        <Typography
                            sx={{
                                flex: 1,
                                textAlign: {xs: 'center', sm: 'center'},
                                fontSize: {xs: '21px', sm: '35px'},
                                fontWeight: 'bold',
                                color: '#fff',
                                marginX: {xs: '0px', lg: '40px'},
                                lineHeight: {xs: '1', sm: '1.5'},
                                marginTop: {xs: '20px'}
                            }}
                        >
                            Strengthen Your Country’s Profile and Drive Action
                        </Typography>
                    </Box>
                </Box>

                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'flex-start',
                        gap: {xs: '45px', md: '13px', lg: '45px'},
                        flexDirection: {xs: 'column', sm: 'row'},
                    }}
                >
                    <Card sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        borderRadius: '0px',
                        minHeight: {xs: '390px', sm: '565px', md: '610px', lg: '505px'},
                        width: {xs: '350px', sm: '250px', md: '300px', lg: '400px'},
                    }}>
                        <CardContent sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            justifyContent: 'center',
                        }}>
                            <Box
                                component="img"
                                src={Img10}
                                alt="Icon 1"
                                sx={{
                                    maxHeight: '85px',
                                    display: 'block',
                                    marginTop: '23px',
                                }}
                            />
                            <Typography sx={{
                                minHeight: '120px',
                                fontWeight: 'bold',
                                marginTop: '16px',
                                textAlign: 'left',
                                color: '#fff',
                                lineHeight: '1.2',
                                fontSize: {xs: '23px', sm: '25px'}
                            }}>
                                CPC Index Education and Training Partners
                            </Typography>
                            <Typography variant="body2" sx={{
                                fontSize: {xs: '17px', sm: '20px'},
                                lineHeight: '1.3',
                                color: '#fff',
                                marginTop: '10px',
                                textAlign: 'left',
                            }}>
                                Deliver and implement high-quality digital literacy education and
                                training programs aligned with CPC Index standards. Measure your
                                program’s impact and connect with CPC Index by integrating the CPC
                                Index Assessment Toolkit for standardized measurement.
                            </Typography>
                        </CardContent>
                    </Card>

                    <Card sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        borderRadius: '0px',
                        minHeight: {xs: '390px', sm: '565px', md: '610px', lg: '505px'},
                        width: {xs: '350px', sm: '250px', md: '300px', lg: '400px'},
                    }}>
                        <CardContent sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            justifyContent: 'center',
                        }}>
                            <Box
                                component="img"
                                src={Img11}
                                alt="Icon 2"
                                sx={{
                                    maxHeight: '80px',
                                    display: 'block',
                                    marginTop: '23px',
                                }}
                            />
                            <Typography variant="h6" sx={{
                                minHeight: '96px',
                                fontWeight: 'bold',
                                marginTop: '20px',
                                color: '#fff',
                                textAlign: 'left',
                                lineHeight: '1.2',
                                fontSize: {xs: '23px', sm: '25px'},
                                marginBottom: {sm: undefined, md: '25px', lg: undefined,}
                            }}>
                                CPC Index Global Research Partners
                            </Typography>
                            <Typography variant="body2" sx={{
                                fontSize: {xs: '17px', sm: '20px'},
                                color: '#fff',
                                lineHeight: '1.3',
                                marginTop: '10px',
                                textAlign: 'left'
                            }}>
                                Collaborate on global research initiatives, co-design data collection methodologies,
                                develop index indicators, and contribute to cutting-edge projects seamlessly
                                integrated
                                into the CPC Index framework.
                            </Typography>
                        </CardContent>
                    </Card>
                </Box>

                <Box sx={{textAlign: 'center', marginTop: '40px', marginBottom: '30px'}}>
                    <Button
                        variant="contained"
                        sx={{
                            backgroundColor: '#003C69',
                            color: '#fff',
                            fontSize: '22px',
                            fontWeight: 'bold',
                            lineHeight: '1.2',
                            textTransform: 'none',
                            border: '2px solid #003C69',
                            borderRadius: '0px',
                            padding: '20px 85px',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                            '&:hover': {
                                backgroundColor: '#003C69',
                            },
                        }}
                        onClick={() => {
                            const section = document.getElementById("homeContactSection");
                            if (section) {
                                section.scrollIntoView({behavior: "smooth"});
                            }
                        }}
                    >
                        JOIN US
                    </Button>
                </Box>
            </Box>

            <Box id="homeContactSection" sx={{
                backgroundColor: "#003C69",
                pt: '90px !important',
                margin: {xs: '0', md: '0', lg: '0'},
                padding: "50px 40px",
                borderBottom: '2px solid #fff',
            }}>
                <Box></Box>
                <Typography sx={{
                    fontSize: {xs: '23px', sm: '45px'},
                    color: "#FFFFFF",
                    textAlign: "center",
                    fontWeight: 'bold',
                    marginBottom: "20px",
                }}>
                    GET INVOLVED
                </Typography>
                <Typography sx={{
                    fontSize: {xs: '17px', sm: '25px'},
                    color: "#FFFFFF",
                    textAlign: "center",
                    lineHeight: "1.2",
                    margin: '10px 5px 30px 5px',
                }}>
                    Together, we can make the Cyberspace safer for children everywhere.<br/>
                    Join the CPC Index community and become a part of this transformative
                    global initiative.
                </Typography>

                {/* Input Fields */}
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "15px",
                        marginBottom: "30px",
                    }}
                >
                    <TextField
                        variant="outlined"
                        placeholder="Your name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        sx={{
                            backgroundColor: "#FFFFFF",
                            borderRadius: "0px",
                            width: {xs: '350px', sm: '600px'},
                        }}
                    />
                    <TextField
                        variant="outlined"
                        placeholder="Your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        sx={{
                            backgroundColor: "#FFFFFF",
                            borderRadius: "0px",
                            width: {xs: '350px', sm: '600px'},
                        }}
                    />
                    <TextField
                        placeholder="Type your message (optional)..."
                        variant="outlined"
                        multiline
                        minRows={4}
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        fullWidth
                        sx={{
                            backgroundColor: "#FFFFFF",
                            borderRadius: "0px",
                            width: {xs: "350px", sm: "600px"},
                        }}
                    />
                </Box>

                {/* Submit Button */}
                <Box textAlign="center">
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        sx={{
                            backgroundColor: '#0096C8',
                            color: '#fff',
                            borderRadius: '0px',
                            fontSize: '22px',
                            fontWeight: 'bold',
                            padding: '18px 85px',
                            '&:hover': {backgroundColor: '#0096C8'},
                        }}
                    >
                        Submit
                    </Button>
                </Box>
            </Box>


            <Footer/>
        </>
    );
};

export default GlobalCPC;